module.exports = __webpack_public_path__ + "img/5.e65a39cb.png";